import script from "./ResponsiveImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResponsiveImage.vue?vue&type=script&lang=ts&setup=true"

import "./ResponsiveImage.vue?vue&type=style&index=0&id=e2d24bb4&lang=scss"

const __exports__ = script;

export default __exports__